<div class="login-landing">
    <div class="login-box text-center">
        <img class="login-logo" src="assets/images/pfjpeg.jpg" alt="PerForma" />
        <div class="logo">Cloud Login</div>
        <div class="login-form-1">
            <form id="login-form" class="text-left" [formGroup]="form" (ngSubmit)="onSubmit()">
                @if (errorMessage) {
                    <div class="login-error">{{ errorMessage }}</div>
                }
                @if (infoMessage) {
                    <div class="login-info">{{ infoMessage }}</div>
                }

                <div class="main-login-form">
                    <div class="login-group">
                        @if (!twoFactorRequired) {
                            <div class="form-group">
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Username or Email"
                                    maxlength="30"
                                    formControlName="username"
                                    autocomplete="username" />
                            </div>
                            <div class="form-group">
                                <input
                                    type="password"
                                    class="form-control"
                                    placeholder="Password"
                                    maxlength="30"
                                    formControlName="password"
                                    autocomplete="current-password" />
                            </div>
                        }

                        @if (twoFactorRequired) {
                            <div class="form-group">
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Code"
                                    maxlength="6"
                                    formControlName="twoFactorCode"
                                    autocomplete="one-time-code" />
                            </div>
                        }
                    </div>
                    <button type="submit" class="login-button" [disabled]="submitting">
                        <i class="fa-solid fa-chevron-right"></i>
                    </button>
                </div>

                <div class="etc-login-form">
                    <p>Forgot your password? <a routerLink="/account/forgot-password">Click here</a></p>
                </div>
            </form>
        </div>
    </div>

    <div class="disable-select login-copyright">
        Copyright &copy; {{ year }}<br />
        <img
            title="Sedona Technologies"
            alt="Sedona Technologies"
            src="assets/images/sedonawhitefancy.png"
            class="disable-select login-copyright-logo" />
    </div>
</div>
